<template>
  <MessageLayout :is-archived="isArchived" :message="message">
    <h6 slot="header" class="message__title">
      Votre ticket du {{ message.date_for_display }} est
      <span :style="{ color: paletteFidmarques.green }">
        à valider
      </span>
    </h6>

    <div slot="content" class="message__body">
      <div
        v-if="!hasPoints && !hasCollectorPieces && !hasRefunds"
        class="section section--empty"
      >
        Le robot n’a rien détecté sur votre ticket
      </div>

      <div v-if="hasPoints" class="section section--points">
        <div class="section__title">
          <div class="section__title__left">
            Points gagnés
          </div>
          <div class="section__title__right">
            <PointsStartSvg
              class="section__title__icon"
              size="16px"
              :color="paletteFidmarques.green"
            />

            <span :style="{ color: paletteFidmarques.green } ">
              {{ message.data.earned_points_count }}
            </span>
            {{ message.data.earned_points_count | pluralize('point', 'points') }}
          </div>
        </div>
        <ul class="section__content">
          <li v-for="(line, idx) in message.data.earned_points" :key="idx" class="line">
            <div class="line__left">
              <div
                class="line__left__left mini-card__wrapper"
                :style="{ borderColor: line.dominant_color }"
              >
                <img :src="line.image_url" :alt="`logo ${line.name}`" class="mini-card__img">
              </div>
              <div class="line__left__right">
                {{ line. name }}
              </div>
            </div>
            <div class="line__right" :style="{ color: line.dominant_color }">
              +{{ line.points }} {{ line.points | pluralize('pt', 'pts') }}
            </div>
          </li>
        </ul>
      </div>

      <div v-if="hasCollectorPieces" class="section section--collector-pieces">
        <div class="section__title">
          <div class="section__title__left">
            Pièces collector
          </div>
          <div class="section__title__right">
            <CollectorPieceSvg
              class="section__title__icon"
              :width="16"
              :color="paletteFidmarques.pink"
            />

            <span :style="{ color: paletteFidmarques.pink } ">
              {{ message.data.earned_collector_pieces_count }}
            </span>
            {{ message.data.earned_collector_pieces_count | pluralize('pièce', 'pièces') }}
          </div>
        </div>
        <ul class="section__content">
          <li v-for="(line, idx) in message.data.earned_collector_pieces" :key="idx" class="line">
            <div class="line__left">
              <div
                class="line__left__left mini-card__wrapper"
                :style="{ borderColor: line.dominant_color }"
              >
                <img :src="line.image_url" :alt="`logo ${line.name}`" class="mini-card__img">
              </div>
              <div class="line__left__right">
                {{ line. name }}
              </div>
            </div>
            <div class="line__right" :style="{ color: line.dominant_color }">
              +{{ line.pieces_count }} {{ line.pieces_count | pluralize('pièce', 'pièces') }}
            </div>
            <!-- TODO: joker percentage
              "earned_joker_participation": 44,
              "formatted_joker_participation": "+44%"
            -->
          </li>
        </ul>
      </div>

      <div v-if="hasRefunds" class="section section--refunds">
        <div class="section__title">
          <div class="section__title__left">
            Remboursements
          </div>
          <div class="section__title__right">
            <EuroSvg
              class="section__title__icon"
              size="16px"
              :color="paletteFidmarques.violet"
            />

            <span :style="{ color: paletteFidmarques.violet } ">
              {{ message.data.pot_increment | money(' €') }}
            </span>
            {{ message.data.pot_increment | pluralize('cagnotté', 'cagnottés') }}
          </div>
        </div>
        <ul class="section__content">
          <li v-for="(line, idx) in message.data.pot_refunds" :key="idx" class="line">
            <div class="line__left">
              <div
                class="line__left__left mini-card__wrapper"
                :style="{ borderColor: line.dominant_color }"
              >
                <img :src="line.image_url" :alt="`logo ${line.name}`" class="mini-card__img">
              </div>
              <div class="line__left__right">
                {{ line. name }}
              </div>
            </div>
            <div class="line__right" :style="{ color: line.dominant_color }">
              +{{ line.amount | money(' €') }}
            </div>
          </li>
        </ul>
      </div>
    </div>

    <ul slot="footer" class="message__actions">
      <li v-for="action in message.actions" :key="action.title" class="message__action">
        <ButtonV3
          class="message__button"
          :text="action.title"
          text-size="12px"
          full-width
          color="white"
          :bg-color="action.button_color"
          :border-color="action.button_color"
          @click="interpreteSchemeUrl(action.scheme_url)"
        />
      </li>
    </ul>
  </MessageLayout>
</template>

<script>
import Mixin from './mixin'

import ButtonV3 from '../../../elements/ButtonV3'

import EuroSvg           from '../../../../assets/images/icons/timeline-message/euro.svg'
import CollectorPieceSvg from '../../../../assets/images/icons/timeline-message/piece.svg'
import PointsStartSvg    from '../../../../assets/images/icons/timeline-message/points-star.svg'

export default {
  components: { ButtonV3, PointsStartSvg, CollectorPieceSvg, EuroSvg },
  mixins: [Mixin],
  props: {
    message: {
      type: Object,
      required: true,
      validator: message =>
        message.hasOwnProperty('data') &&
        message.data.hasOwnProperty('earned_points') &&
        message.data.hasOwnProperty('earned_points_count') &&
        message.data.hasOwnProperty('earned_collector_pieces') &&
        message.data.hasOwnProperty('earned_collector_pieces_count') &&
        message.data.hasOwnProperty('pot_increment') &&
        message.data.hasOwnProperty('pot_refunds') &&
        // message.data.hasOwnProperty('used_coupons_count') &&
        true
      ,
    },
  },
  computed: {
    hasPoints () {
      // return this.message.data.earned_points_count !== 0
      return this.message.data.earned_points.length !== 0
    },
    hasCollectorPieces () {
      // return this.message.data.earned_collector_pieces_count !== 0
      return this.message.data.earned_collector_pieces.length !== 0
    },
    hasRefunds () {
      // return this.message.data.pot_increment !== 0
      return this.message.data.pot_refunds.length !== 0
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~assets/css/mixins";
@import "~assets/css/variables";

.section--empty {
  text-align: center;
  background-color: $color-border-gray-ul;
  padding: 1.5rem 1rem;
}

.section:last-child {
  border-bottom: 1px solid $color-border-gray-disabled;
}
.section--empty:last-child {
  border-bottom: none;
}

.message__title {
  @include font-family__oswald;
  padding: 0;
  margin: 0;
}
.message__body {
  padding: 0;
  margin: 0;
}

.section__title {
  display: flex;
  justify-content: space-between;
  background-color: $color-border-gray-ul;
  padding: 0.5rem 1rem;
}

.section__title__icon {
  vertical-align: bottom;
}

.section__content {
  margin: 0;
  padding: 0;
}

.line {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0.5rem 1rem;
}
.line + .line {
  border-top: 1px solid $color-border-gray-disabled;
}

.line__left {
  display: flex;
  align-items: center;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.line__right {
  white-space: nowrap;
  margin-left: 0.5rem;
}

.mini-card__wrapper {
  padding: 2px;
  margin-right: 0.5rem;
  width: 48px;
  height: 30px;
  border-radius: 5px;
  border-style: solid;
  border-width: 1px;
  display: flex;
}
.mini-card__img {
  border-radius: 5px;
}

.message__actions {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}
.message__action {
  flex: 1;
}
.message__action + .message__action {
  margin-left: 1rem;
}
</style>
